import LabPage from "../components/layout/LabPage";
import { FileImage, QrCode, Wand2, Crop, Megaphone, Printer, ImageIcon, Layout } from "lucide-react";

export default function FlyerLab() {
  return (
    <LabPage
      testId="flyer-lab-page"
      kicker="FlyerLab"
      title="Flyers, posters, one-sheets — print or social"
      description="Promo graphics that convert. Auto-applied brand, headline AI, QR codes, print bleed, and social resize."
      heroImage="https://images.unsplash.com/photo-1611162617213-7d7a39e9b1d7?w=900&q=80"
      heroTone="lime"
      actions={[{ label: "Generate Flyer", icon: Wand2, to: "/create" }]}
      quickActions={[
        { label: "Headline AI", icon: Megaphone },
        { label: "Add QR", icon: QrCode },
        { label: "Print Bleed", icon: Printer },
        { label: "Social Resize", icon: Layout },
      ]}
      features={[
        { icon: FileImage, title: "Print + Digital", description: "Flyer, poster, brochure, one-sheet, social graphic." },
        { icon: Megaphone, title: "AI Copywriting", description: "Headline, subhead, CTA — tuned to your brand voice." },
        { icon: ImageIcon, title: "Image Replacement", description: "Swap backgrounds, products, mockups in one click." },
        { icon: Crop, title: "Print Bleed & Crop", description: "Auto bleed, safe area, and crop marks." },
        { icon: QrCode, title: "QR Codes", description: "Smart QR with tracking, lead magnet links, registration." },
        { icon: Layout, title: "Social Resize", description: "Instagram, Facebook, Twitter, LinkedIn — auto layouts." },
      ]}
      sampleAssets={[
        { title: "Webinar Flyer", thumb: "https://images.unsplash.com/photo-1611162617213-7d7a39e9b1d7?w=500&q=80", meta: "Letter · Print" },
        { title: "Book Launch Poster", thumb: "https://images.unsplash.com/photo-1587614382346-4ec70e388b28?w=500&q=80", meta: "11x17 · Print" },
        { title: "Challenge Promo", thumb: "https://images.unsplash.com/photo-1556761175-4b46a572b786?w=500&q=80", meta: "Square · Social" },
        { title: "Event One-Sheet", thumb: "https://images.unsplash.com/photo-1611224923853-80b023f02d71?w=500&q=80", meta: "Letter · Digital" },
      ]}
    />
  );
}
